// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"4501c80c","769":"6f8a565d"}[chunkId] + ".chunk.js";
};